import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface VendedorOption {
    id: number
    nome: string
}

export interface ContratoAplicativo {
    razaoSocial: string | null
    nomeFantasia: string | null
    cnpj: string | null
    nomeResponsavel: string | null
    emailResponsavel: string | null
    endereco: string | null
    valorAdesao: number | null
    valorMensalidade: number | null
    metaVendas: number | null
    formaPagamentoAdesao: string | null
    idVendedor: number | null
    nomeVendedor: string | null
    termosEPolitica: string | null
    vendedores: VendedorOption[]
    podeEditar?: boolean
}

export interface AtualizarContratoPayload {
    razaoSocial: string | null
    nomeFantasia: string | null
    cnpj: string | null
    nomeResponsavel: string | null
    emailResponsavel: string | null
    endereco: string | null
    valorAdesao: number | null
    valorMensalidade: number | null
    metaVendas: number | null
    formaPagamentoAdesao: string | null
    idVendedor: number | null
    termosEPolitica: string | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterContrato = async function (
    authorization: string
): Promise<ContratoAplicativo | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ContratoAplicativo>>("aplicativoDados/ObterContratoAplicativo", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ContratoAplicativo>(response, "ObterContratoAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "ObterContratoAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const atualizarContrato = async function (
    authorization: string,
    payload: AtualizarContratoPayload
): Promise<ContratoAplicativo | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<ContratoAplicativo>>(
                "aplicativoDados/AtualizarContratoAplicativo",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ContratoAplicativo>(response, "AtualizarContratoAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "AtualizarContratoAplicativo", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
